import React from 'react';
import { Dialog, FormControl, Grid, MenuItem } from '@mui/material';
import styles from '../../../../../custom/style.module.css';
import { CustomButton, CustomTextField, CustomDialogTitle, CustomDialogAction, CustomInputLabel, StyledCard, InputProps, CustomSelect, CustomDialogContent, SelectInputProps, CustomFormHelperText } from '../../../../../custom/components';
import { CloseIconBtn, contractType, checklistRoles } from 'custom/constants';

const AddChecklistModal = (props) => {
  const { action, addChecklist, editChecklist, onChangeChecklist } = props;
  const fltReportType = [ 'Inbound Flight Report', 'Outbound Flight Report', 'Flight Report'];
  return (
    <div>
      <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'checklist'} onClose={props.onClose} maxWidth={'sm'} fullWidth>
        <CustomDialogTitle id='form-dialog-title'>
          {action == 'add' ? 'Add' : 'Edit'} Checklist
          <CloseIconBtn onClick={props.onClose} />
        </CustomDialogTitle>
        <form className={styles.w100} onSubmit={action == 'add' ? addChecklist : editChecklist} onReset={props.onClose}>
          <CustomDialogContent>
            <StyledCard>
              <Grid container spacing={2} >
                <Grid item xs={12} md={12}>
                  <CustomInputLabel htmlFor='description' required>Checklist Description</CustomInputLabel>
                  <CustomTextField
                    {...InputProps}
                    fullWidth
                    autoFocus
                    id='description'
                    placeholder='Checklist'
                    type='text'
                    name='description'
                    onChange={onChangeChecklist}
                    value={props.checklistField.description || ''}
                    error={props.checklistErrors.description}
                    helperText={props.checklistErrors.description}
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <CustomInputLabel id='employee_group_label' aria-label='Employee-group' required>To be entered by (Employee Group)</CustomInputLabel>
                  <FormControl fullWidth error={props.checklistErrors.role}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='role'
                      labelId='employee_group_label'
                      fullWidth
                      onChange={onChangeChecklist}
                      name='role'
                      value={!props.checklistField.role ? 'placeholder' : props.checklistField.role}
                      classes={{ select: !props.checklistField.role ? styles.colorPlaceholder : '' }}
                    >
                      <MenuItem value='placeholder' disabled={true}>Select a Role</MenuItem>
                      {checklistRoles.map((role, i) => (
                        <MenuItem key={i} value={role.value}>
                          {role.value}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                    <CustomFormHelperText>{props.checklistErrors.role}</CustomFormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                  <CustomInputLabel id='report_type_label' required>Inbound/Outbound Flight Report</CustomInputLabel>
                  <FormControl fullWidth error={props.checklistErrors.report_type}>
                    <CustomSelect
                      {...SelectInputProps}
                      id='report_type'
                      labelId='report_type_label'
                      fullWidth
                      onChange={onChangeChecklist}
                      name='report_type'
                      value={!props.checklistField.report_type ? 'placeholder' : props.checklistField.report_type}
                      classes={{ select: !props.checklistField.report_type ? styles.colorPlaceholder : '' }}
                    >
                      <MenuItem value='placeholder' disabled={true}>Select a type</MenuItem>
                      <MenuItem value={'All'}>All</MenuItem>
                      {fltReportType.map((type, i) => (
                        <MenuItem key={i} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </CustomSelect>
                    <CustomFormHelperText>{props.checklistErrors.report_type}</CustomFormHelperText>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12}>
                  <CustomInputLabel id='contract_types' required>Department</CustomInputLabel>
                  <FormControl fullWidth error={props.checklistErrors.contract_types}>
                    <CustomSelect
                      {...SelectInputProps}
                      fullWidth
                      id='contract_types'
                      labelId='contract_types'
                      name='contract_types'
                      onChange={onChangeChecklist}
                      value={!props.checklistField.contract_types ? 'placeholder' : props.checklistField.contract_types}
                      classes={{ select: !props.checklistField.contract_types ? styles.colorPlaceholder : '' }}
                    >
                      <MenuItem value='placeholder' disabled>Select Department</MenuItem>
                      <MenuItem value={contractType.cargo_handling}>{contractType.cargo_handling}</MenuItem>
                      <MenuItem value={contractType.flight_ops}>{contractType.flight_ops}</MenuItem>
                      <MenuItem value={contractType.drayage}>{contractType.drayage}</MenuItem>
                    </CustomSelect>
                  </FormControl>
                </Grid>
              </Grid>
            </StyledCard>

          </CustomDialogContent>
          <CustomDialogAction className={`${styles.fSpaceBtw}`}>
            <CustomButton variant='contained' type='reset'> Close </CustomButton>
            <CustomButton variant='contained' type='submit'>{ action == 'add' ? 'Submit' : 'Update'}</CustomButton>
          </CustomDialogAction>
        </form>
      </Dialog>
    </div>
  );
};
export default AddChecklistModal;